import React, { useContext } from 'react';
import { useTheme } from 'ThemeContext';
import { AppSettingsContext } from 'AppSettingsContext';

import Widgets from 'components/Widgets';

import { Wrapper, Container, Box, Column, Text } from './FooterDetails.style';

function FooterDetails({
  widgets = {
    0: [],
    1: [],
    2: [],
    3: []
  }
}) {
  const [appSettings] = useContext(AppSettingsContext);
  const theme = useTheme();
  return (
    <>
      <Wrapper theme={theme.footerDetails.wrapper}>
        <Container
          widerTheme={appSettings.theme === 6 ? String(true) : undefined}
          narrowerTheme={appSettings.theme === 4 ? String(true) : undefined}
        >
          <Box
            differentGrid={appSettings.theme === 6 ? String(true) : undefined}
          >
            <Column
              theme={theme.footerDetails.column}
              differentColumn0={
                appSettings.theme === 6 ? String(true) : undefined
              }
            >
              <Text theme={theme.footerDetails.text}>
                <Widgets widgets={widgets[0]} />
              </Text>
            </Column>
            <Column
              theme={theme.footerDetails.column}
              differentColumn1={
                appSettings.theme === 6 ? String(true) : undefined
              }
            >
              <Text theme={theme.footerDetails.text}>
                <Widgets widgets={widgets[1]} />
              </Text>
            </Column>
            <Column
              theme={theme.footerDetails.column}
              differentColumn2={
                appSettings.theme === 6 ? String(true) : undefined
              }
            >
              <Text theme={theme.footerDetails.text}>
                <Widgets widgets={widgets[2]} />
              </Text>
            </Column>
            <Column
              theme={theme.footerDetails.column}
              noBorder
              differentColumn3={
                appSettings.theme === 6 ? String(true) : undefined
              }
            >
              <Text theme={theme.footerDetails.text}>
                <Widgets widgets={widgets[3]} />
              </Text>
            </Column>
          </Box>
        </Container>
      </Wrapper>
    </>
  );
}

export default FooterDetails;
